export default __webpack_public_path__ + "static/media/logo-nonogramdle.0568aab8.png";